import styled from "styled-components";

import { media } from "../../styles/media";

export const AppShellStyles = styled.div`
  /* The mobile top bar only exists below the tablet breakpoint; on desktop the
     fixed 240px SideMenu is the sole navigation and the layout is unchanged. */
  .mobileTopBar {
    display: none;
  }

  /* Dimmed overlay behind the open drawer. Lives here (not inside SideMenu)
     because SideMenu is transformed on mobile, which would make a fixed child
     position against the drawer instead of the viewport. */
  .drawerBackdrop {
    display: none;
  }

  ${({ theme }) => media.maxTablet`
    .mobileTopBar {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      height: 56px;
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 0 16px;
      background: ${theme.colors.semantic.container.white};
      border-bottom: 1px solid ${theme.colors.semantic.separator};
      box-shadow: ${theme.shadows.cardAlt};
      z-index: ${theme.zIndex.topBar};

      .hamburger {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        padding: 0;
        border: none;
        background: transparent;
        color: ${theme.colors.semantic.icon.strong};
        cursor: pointer;
        border-radius: 8px;
        transition: background 0.15s ease;

        &:hover {
          background: ${theme.colors.accent[50]};
        }
      }

      .topBarLogo {
        height: 28px;
        width: auto;
        color: ${theme.colors.primary[900]};
      }

      .topBarBell {
        position: relative;
        margin-left: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        padding: 0;
        border: none;
        background: transparent;
        color: ${theme.colors.primary[600]};
        cursor: pointer;
        border-radius: 8px;
        transition: background 0.15s ease, color 0.15s ease;

        &:hover {
          background: ${theme.colors.accent[50]};
          color: ${theme.colors.accent[500]};
        }

        .topBarBellBadge {
          position: absolute;
          top: -2px;
          right: -2px;
          min-width: 18px;
          height: 18px;
          padding: 0 5px;
          font-size: 10px;
          border: 2px solid ${theme.colors.semantic.container.white};
        }
      }
    }

    .drawerBackdrop {
      display: block;
      position: fixed;
      inset: 0;
      background: ${theme.colors.primary[900]}33;
      opacity: 0;
      visibility: hidden;
      pointer-events: none;
      transition: opacity 0.32s ease, visibility 0s linear 0.32s;
      z-index: ${theme.zIndex.drawerBackdrop};

      &.isOpen {
        opacity: 1;
        visibility: visible;
        pointer-events: auto;
        transition: opacity 0.32s ease, visibility 0s linear 0s;
      }
    }
  `}
`;
